import { parseFilename } from '../utils/fileUtils.js';
import Findable from '../mixins/Findable.js';
class UserClient {
    static service = 'user';
    apiClient;
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    create(params) {
        const endpoint = this.makeEndpoint('create');
        return this.apiClient.exec(endpoint, params);
    }
    update(params) {
        const endpoint = this.makeEndpoint('update');
        return this.apiClient.exec(endpoint, params);
    }
    updatePassword(params) {
        const endpoint = this.makeEndpoint('update-password');
        // @ts-ignore
        return this.apiClient.exec(endpoint, params);
    }
    activate(params) {
        const endpoint = this.makeEndpoint('activate');
        return this.apiClient.exec(endpoint, params);
    }
    count(params) {
        const endpoint = this.makeEndpoint('count');
        return this.apiClient.exec(endpoint, params);
    }
    async uploadImage({ asset, ...rest }) {
        const filename = parseFilename(asset);
        const data = [];
        data.push({
            name: 'url',
            value: (await Promise.resolve(asset.slice())),
            filename,
        });
        data.push({ name: 'q', value: JSON.stringify(rest) });
        const endpoint = this.makeEndpoint('set-image');
        return await this.apiClient.upload(endpoint, data);
    }
    removeImage(params) {
        const endpoint = this.makeEndpoint('remove-image');
        return this.apiClient.exec(endpoint, params);
    }
    getImage(params) {
        const endpoint = this.makeEndpoint('get-image');
        return this.apiClient.exec(endpoint, params);
    }
    setHomeAccount(params) {
        const endpoint = this.makeEndpoint('set-home-account');
        return this.apiClient.exec(endpoint, params);
    }
    remove(params) {
        const endpoint = this.makeEndpoint('remove');
        return this.apiClient.exec(endpoint, params);
    }
    makeEndpoint(operation) {
        return `${UserClient.service}/${operation}`;
    }
}
// Decorate service with mixins
const DecoratedClient = Findable(UserClient);
export default DecoratedClient;
